import React, { useState } from 'react';
import { DataManager } from '../../services/dataManager';

const DataBackupManager = () => {
    const [exporting, setExporting] = useState(false);
    const [status, setStatus] = useState(null);

    // Export complete snapshot for counselor peace of mind
    const handleExportBackup = async () => {
        try {
            setExporting(true);
            setStatus('Generazione backup in corso...');

            const [clients, counselors, groupReports] = await Promise.all([
                DataManager.getClients(),
                DataManager.getAllCounselors(),
                DataManager.getAllGroupReports()
            ]);

            const backupData = {
                exportedAt: new Date().toISOString(),
                version: '2.0',
                appName: 'AwarenessTool Studio',
                totalClients: (clients || []).length,
                totalCounselors: (counselors || []).length,
                totalGroupReports: (groupReports || []).length,
                clients: clients || [],
                counselors: counselors || [],
                groupReports: groupReports || []
            };

            const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(backupData, null, 2));
            const downloadAnchor = document.createElement('a');
            const dateStr = new Date().toISOString().split('T')[0];
            downloadAnchor.setAttribute("href", dataStr);
            downloadAnchor.setAttribute("download", `AwarenessTool_Backup_Studio_${dateStr}.json`);
            document.body.appendChild(downloadAnchor);
            downloadAnchor.click();
            downloadAnchor.remove();

            setStatus(`✅ Backup esportato con successo! (${backupData.totalClients} clienti, ${backupData.totalGroupReports} incontri di gruppo).`);
        } catch (err) {
            console.error("Errore esportazione backup:", err);
            setStatus('❌ Errore durante l\'esportazione: ' + err.message);
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="bg-white border-2 border-slate-200 rounded-3xl p-6 shadow-sm space-y-6">
            <div className="flex items-center justify-between flex-wrap gap-3 pb-4 border-b border-slate-100">
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-teal-50 text-teal-700 flex items-center justify-center text-2xl font-bold">
                        ☁️
                    </div>
                    <div>
                        <h3 className="text-lg font-black text-slate-900 tracking-tight">
                            Database Cloud & Sicurezza Studio
                        </h3>
                        <p className="text-xs text-slate-500 font-medium">
                            Sincronizzazione in tempo reale con Firebase Firestore & Auth
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-800 px-3 py-1.5 rounded-full text-xs font-bold">
                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                    <span>Cloud Connesso & Sincronizzato</span>
                </div>
            </div>

            <div className="space-y-4">
                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200 text-xs text-slate-700 space-y-2">
                    <p className="font-bold text-slate-900">
                        🔒 Protezione e Continuità dei Dati
                    </p>
                    <p className="leading-relaxed">
                        Tutte le schede anagrafiche, i contratti di counseling, le note dei colloqui e i report di gruppo vengono salvati e cifrati direttamente nel cloud protetto di AwarenessTool. Non occorre eseguire alcuna migrazione manuale.
                    </p>
                </div>

                <div className="p-5 bg-white rounded-2xl border border-slate-200 shadow-xs space-y-3">
                    <div className="flex justify-between items-start">
                        <div>
                            <h4 className="font-bold text-slate-900 text-sm">
                                Esporta Copia di Sicurezza Locale (JSON)
                            </h4>
                            <p className="text-xs text-slate-500 mt-0.5">
                                Scarica un archivio completo con tutti i clienti e verbali di gruppo per archivio offline o conformità.
                            </p>
                        </div>
                        <span className="text-2xl">💾</span>
                    </div>

                    <button
                        onClick={handleExportBackup}
                        disabled={exporting}
                        className="w-full py-3 bg-[#1e3847] hover:bg-[#24485d] text-white rounded-xl font-bold text-xs sm:text-sm shadow-xs transition flex justify-center items-center gap-2 active:scale-98 disabled:opacity-50"
                    >
                        {exporting ? '⏳ Generazione archivio in corso...' : '📥 Scarica Backup Completo (.JSON)'}
                    </button>

                    {status && (
                        <div className={`p-3 rounded-xl text-xs font-medium border ${
                            status.startsWith('✅') 
                                ? 'bg-emerald-50 text-emerald-800 border-emerald-200' 
                                : 'bg-rose-50 text-rose-800 border-rose-200'
                        }`}>
                            {status}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DataBackupManager;
